<div id="blueimp-gallery" class="blueimp-gallery blueimp-gallery-controls" aria-label="image gallery" aria-modal="true"
    role="dialog">
    <div class="slides" aria-live="polite"></div>
    <h3 class="title"></h3>
    <a class="prev" aria-controls="blueimp-gallery" aria-label="previous slide" aria-keyshortcuts="ArrowLeft"></a>
    <a class="next" aria-controls="blueimp-gallery" aria-label="next slide" aria-keyshortcuts="ArrowRight"></a>
    <a class="close" aria-controls="blueimp-gallery" aria-label="close" aria-keyshortcuts="Escape"></a>
    <a class="play-pause" aria-controls="blueimp-gallery" aria-label="play slideshow" aria-keyshortcuts="Space"
        aria-pressed="false" role="button"></a>
    <ol class="indicator"></ol>
</div>
<main role="main" class="not-home-page">
    <div class="row">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="banner"><img src="" alt="" /></div>
                    <app-breadcrumb></app-breadcrumb>
                </div>
            </div>
            <div *ngIf="topImage">
                <div class="row">
                    <div class="col-md-3 side-bar">
                        <div class="selected-item"> </div>
                        <nav id="sidebar">
                            <app-statique-menu [lg]="outputLg" [cururl]="currentUrl"></app-statique-menu>
                        </nav>
                    </div>
                    <div class="col-md-9">
                        <div id="container">
                            <!-- <div class="projects">Photothèque</div> -->
                            <br />
                            <br />
                            <h2>
                                {{ "Phototheque" | translate }}
                            </h2>

                            <div class="gallery">
                                <div class="row">
                                    <div class="col-lg-3 col-md-4 col-s-12 containerTop" *ngFor="let item of topImages">
                                        <a href="javascript:void(0)" (click)="chargeGallery(item)">
                                            <div>
                                                <img [src]="item.image" /><br />
                                                <span>{{ item.title }}</span>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <hr>
                            <h2>{{ "Videotheque" | translate }}</h2>
                            <div class="gallery">

                                <div id="blueimp-gallery-carousel"
                                    class="blueimp-gallery blueimp-gallery-carousel blueimp-gallery-controls"
                                    aria-label="image carousel">
                                    <div class="slides" aria-live="off"></div>
                                    <h3 class="title"></h3>
                                    <a class="prev" aria-controls="blueimp-gallery-carousel"
                                        aria-label="previous slide"></a>
                                    <a class="next" aria-controls="blueimp-gallery-carousel"
                                        aria-label="next slide"></a>
                                    <ol class="indicator"></ol>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="!topImage">

                <div class="col-md-3 side-bar">
                    <div class="selected-item"> </div>
                    <nav id="sidebar">
                        <app-statique-menu [lg]="outputLg" [cururl]="currentUrl"></app-statique-menu>
                    </nav>
                </div>
                <div class="col-md-9">
                    <div *ngIf="!fromSimulatorPage">
                        <a href="javascript:void(0)" (click)="setToTrue()"><i class="fa fa-reply"
                                style=" font-size: 22px;"></i></a>
                    </div>
                    <div *ngIf="fromSimulatorPage">
                        <a href="javascript:void(0)"><i class="fa fa-reply"
                                [routerLink]="['/formation-portuaire/simulateur']" routerLinkActive="router-link-active"
                                style=" font-size: 22px;"></i></a>
                    </div>
                    <h3>{{titrePhoto}}</h3>
                    <br />
                    <div id="links"></div>
                </div>
                <div class="col-2"></div>
            </div>
        </div>
    </div>
</main>